import {appFetch, AppFetchResponse} from "../utils/appFetch";

export const getTwilioSender = async (domain: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: "shop-whatsapp-sender",
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain,
    });
}